module.exports = __webpack_public_path__ + "img/首页海报1.c1f8e73e.jpg";